import React from 'react';

const PaymentHistory = ({ payments }) => {
  if (!payments || payments.length === 0) {
    return (
      <div className="text-center py-8">
        <i className="fas fa-receipt text-4xl mb-4" style={{ color: '#948979' }}></i>
        <p style={{ color: '#393E46' }}>No purchases yet</p>
        <p className="text-sm mt-2" style={{ color: '#393E46', opacity: 0.7 }}>Your listing pack purchases will appear here</p>
      </div>
    );
  }

  const getPaymentMethodIcon = (method) => {
    switch (method) {
      case 'upi': return 'fas fa-mobile-alt';
      case 'card': return 'fas fa-credit-card';
      case 'netbanking': return 'fas fa-university';
      case 'wallet': return 'fas fa-wallet';
      default: return 'fas fa-money-bill';
    }
  };

  const getPaymentMethodName = (method) => {
    switch (method) {
      case 'upi': return 'UPI';
      case 'card': return 'Card';
      case 'netbanking': return 'Net Banking';
      case 'wallet': return 'Wallet';
      default: return 'Unknown';
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      completed: 'bg-green-100 text-green-800',
      pending: 'bg-yellow-100 text-yellow-800',
      failed: 'bg-red-100 text-red-800',
      refunded: 'bg-blue-100 text-blue-800'
    };
    
    return badges[status] || badges.pending;
  };

  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-4" style={{ color: '#222831' }}>Purchase History</h4>
      
      {payments.map((payment) => (
        <div key={payment._id} className="bg-white rounded-lg border p-4 hover:shadow-md transition-shadow" style={{ borderColor: '#948979' }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#948979', opacity: 0.2 }}>
                <i className={`${getPaymentMethodIcon(payment.method)}`} style={{ color: '#222831' }}></i>
              </div>
              <div>
                <p className="font-medium" style={{ color: '#222831' }}>₹{payment.amount} - Listing Pack</p>
                <p className="text-sm" style={{ color: '#393E46' }}>
                  {getPaymentMethodName(payment.method)} • {payment.listingsGranted} listings
                </p>
                <p className="text-xs" style={{ color: '#393E46', opacity: 0.7 }}>
                  {new Date(payment.createdAt).toLocaleDateString('en-IN', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              </div>
            </div>
            
            <div className="text-right">
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(payment.status)}`}>
                {payment.status.charAt(0).toUpperCase() + payment.status.slice(1)}
              </span>
              {payment.paymentId && (
                <p className="text-xs mt-1" style={{ color: '#393E46', opacity: 0.7 }}>
                  ID: {payment.paymentId.slice(-8)}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaymentHistory;